//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.AccountResale
import com.tixforgigs.apax.models.ItemType
import com.tixforgigs.apax.models.PersonalizationField

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The order ticket model, based on base ticket model
* 
* @param contingentId The unique identifier of the contingent to which this ticket belongs
* @param contingentTitle The localized event title
* @param eventId The unique identifier of the event to which this ticket belongs
* @param eventTitle The localized event title
* @param isPersonalized [DEPRECATED - use personalizationFields] personalizationFields == null indicates isPersonalized == false [OLD] Boolean indicating whether the ticket is personalized
* @param itemType 
* @param personalizationMissing Bool if a personalization for the ticket is missing
* @param resaleEnabled Bool if the resale is enabled
* @param runningValue A sequential number that is incremented when changes are made
* @param ticketId The unique identifier of the ticket
* @param appleWalletLink The apple wallet link (pkpass)
* @param code The unique ticket code for entry control
* @param dbVersion The version from db. Used for requesting updates based on a version.
* @param googleWalletLink The google wallet link (event pass)
* @param isCurrentUserTicketOwner Bool if the current user is ticket owner
* @param orderItemId The order item id
* @param pdfDownloadLink The download link
* @param personalizationFields A list of personalization fields available for this event. Mandatory fields are marked with required
* @param productId The unique identifier of the product to which this ticket belongs
* @param ticketOwnerEmail The email address of the ticket holder
* @param ticketResale 
*/
@Serializable

data class OrderTicket (


      /* The unique identifier of the contingent to which this ticket belongs */
    @SerialName(value = "contingentId") @Required val contingentId: kotlin.Int,


      /* The localized event title */
    @SerialName(value = "contingentTitle") @Required val contingentTitle: kotlin.String,


      /* The unique identifier of the event to which this ticket belongs */
    @SerialName(value = "eventId") @Required val eventId: kotlin.Int,


      /* The localized event title */
    @SerialName(value = "eventTitle") @Required val eventTitle: kotlin.String,


      /* [DEPRECATED - use personalizationFields] personalizationFields == null indicates isPersonalized == false [OLD] Boolean indicating whether the ticket is personalized */
    @Deprecated(message = "This property is deprecated.")
    @SerialName(value = "isPersonalized") @Required val isPersonalized: kotlin.Boolean,


      @SerialName(value = "itemType") @Required val itemType: ItemType?,


      /* Bool if a personalization for the ticket is missing */
    @SerialName(value = "personalizationMissing") @Required val personalizationMissing: kotlin.Boolean,


      /* Bool if the resale is enabled */
    @SerialName(value = "resaleEnabled") @Required val resaleEnabled: kotlin.Boolean,


      /* A sequential number that is incremented when changes are made */
    @SerialName(value = "runningValue") @Required val runningValue: kotlin.Int,


      /* The unique identifier of the ticket */
    @SerialName(value = "ticketId") @Required val ticketId: kotlin.Int,


      /* The apple wallet link (pkpass) */
    @SerialName(value = "appleWalletLink") val appleWalletLink: kotlin.String? = null,


      /* The unique ticket code for entry control */
    @SerialName(value = "code") val code: kotlin.String? = null,


      /* The version from db. Used for requesting updates based on a version. */
    @SerialName(value = "dbVersion") val dbVersion: kotlin.Long? = 0L,


      /* The google wallet link (event pass) */
    @SerialName(value = "googleWalletLink") val googleWalletLink: kotlin.String? = null,


      /* Bool if the current user is ticket owner */
    @SerialName(value = "isCurrentUserTicketOwner") val isCurrentUserTicketOwner: kotlin.Boolean? = null,


      /* The order item id */
    @SerialName(value = "orderItemId") val orderItemId: kotlin.Int? = null,


      /* The download link */
    @SerialName(value = "pdfDownloadLink") val pdfDownloadLink: kotlin.String? = null,


      /* A list of personalization fields available for this event. Mandatory fields are marked with required */
    @SerialName(value = "personalizationFields") val personalizationFields: kotlin.collections.List<PersonalizationField>? = null,


      /* The unique identifier of the product to which this ticket belongs */
    @SerialName(value = "productId") val productId: kotlin.Int? = null,


      /* The email address of the ticket holder */
    @SerialName(value = "ticketOwnerEmail") val ticketOwnerEmail: kotlin.String? = null,


      @SerialName(value = "ticketResale") val ticketResale: AccountResale? = null


) {




  }

